import { FC, useEffect, useState } from 'react'
import Ping from 'ping-url'

import { TableDiv } from 'featureSliced/widgets/Cart/styled'

import {
  TipsContainer,
  TipsGrid,
  TipsModalButton,
  TipsModalButtonPercentage,
  TipsGridContainer,
  TipsInput,
  InputCurrency,
  TipsTotal,
  InputTitle,
  InputContainer,
  SubFooterTips,
} from './styled'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { convertToPrice } from 'featureSliced/shared/utils/convertToPrice'
import {
  getPrecision,
  roundValueTo,
} from 'featureSliced/shared/utils/roundValueTo'

// TIPS_ARRAY must be 3-items lenth to have a correct layout.
const TIPS_ARRAY: [number, number, number] = [5, 10, 15]
export const DEFAULT_TIPS_VALUE = 5

type TipsProps = {
  total: number
  tipsValue: number
  onChange: (value: number) => void
}

export const Tips: FC<TipsProps> = ({ total, tipsValue, onChange }) => {
  // Hooks
  const t = useTranslations()

  //Store
  const { Currency } = useMySelector((state) => state.app.companyData)
  const [inputValue, setInputValue] = useState<string>()

  // useEffects
  useEffect(() => {
    if (!inputValue?.length && tipsValue) {
      setInputValue(`${tipsValue}`)
    }
  }, [tipsValue])

  useEffect(() => {
    onChange(getTipsValue(DEFAULT_TIPS_VALUE))
  }, [DEFAULT_TIPS_VALUE])

  // Functions
  const handleTileClick = (value: number) => {
    if (tipsValue === value) {
      setInputValue('0')
      onChange(0)
    }
    if (tipsValue !== value) {
      setInputValue(convertToPrice(value))
      onChange(value)
    }
  }

  const getTipsValue = (percentage: number) => {
    const originalTipsValue = total * (percentage / 100)
    const roundedValue = preciseValue(originalTipsValue)
    return roundedValue
  }

  const preciseValue = (value: number) => {
    const precision = getPrecision(Currency)
    const roundedValue = roundValueTo(value, precision)
    return roundedValue
  }

  const handleInputChange = (e: any) => {
    const rawValue = e.currentTarget.value

    if (
      rawValue !== '' &&
      (!/^[0-9.,]+$/.test(rawValue) ||
        (rawValue.match(/[.,]/g) || []).length > 1)
    ) {
      return
    }

    const displayValue = rawValue.replace(',', '.')
    setInputValue(displayValue)

    if (displayValue === '') {
      onChange(0)
      return
    }

    if (displayValue.endsWith('.')) {
      onChange(Number(displayValue.slice(0, -1)))
      return
    }

    const numericValue = Number(displayValue)
    if (!Number.isNaN(numericValue)) {
      const rounded = preciseValue(numericValue)
      const [intPart, decPart] = displayValue.split('.')
      if (decPart === '0') {
        setInputValue(`${intPart}.0`)
      } else {
        setInputValue(String(rounded))
      }
      onChange(rounded)
    }
  }

  return (
    <TipsContainer>
      <div>
        <TableDiv>{t('order.tips')}</TableDiv>
        <TipsGrid>
          {TIPS_ARRAY.map((percentage) => {
            const value = getTipsValue(percentage)
            return (
              <TipsModalButton
                key={`tips_${value}`}
                onClick={() => handleTileClick(value)}
                buttonType={tipsValue === value ? 'stroke' : 'gray'}
              >
                <TipsModalButtonPercentage>
                  {percentage}%
                </TipsModalButtonPercentage>
                <p style={{ margin: '0' }}>
                  {convertToPrice(value)} {Currency || ''}
                </p>
              </TipsModalButton>
            )
          })}
          <TipsGridContainer gc="1 / -1" gr="2 / 3">
            <InputTitle>{t('order.manualInput')}:</InputTitle>
            <InputContainer height="60px">
              <TipsInput
                inputMode="numeric"
                textColor="#434343"
                value={inputValue}
                onChange={handleInputChange}
                // onFocus={() => {
                //   setInputValue('')
                //   setInputValue(tipsValue)
                // }}
                // onBlur={() => setInputValue(convertToPrice(inputValue))}
              />
              <InputCurrency>{Currency || ''}</InputCurrency>
            </InputContainer>
          </TipsGridContainer>
        </TipsGrid>
      </div>
    </TipsContainer>
  )
}
